import {Image} from '@primer/react-brand'

// Assets
import ImageBg from './_assets/bg.webp'

import Styles from './Visual.module.css'

export function Visual() {
  return (
    <div className={Styles.Visual}>
      <Image className={Styles.Image} src={ImageBg} width={1600} height={450} alt="" loading="lazy" />
    </div>
  )
}

try{ Visual.displayName ||= 'Visual' } catch {}